import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { SpeechRecognitionEffects } from './store';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([SpeechRecognitionEffects.SpeechRecognitionEffects])
  ],
  declarations: [],
  exports: [],
})
export class SpeechModule {}